<template>
  <div>
    <b-form-group label="Full Name" class="mb-3">
      <b-form-input
        v-model="form.full_name"
        type="text"
        class="form-control"
        placeholder="Full Name"
        autocomplete="full_name"
        :state="vuelidate.full_name.$dirty ? !vuelidate.full_name.$invalid : null"
      />
    </b-form-group>

    <b-form-group label="Short Name" class="mb-3">
      <b-form-input
        v-model="form.short_name"
        type="text"
        class="form-control"
        placeholder="Short Name"
        autocomplete="full_name"
        :state="vuelidate.short_name.$dirty ? !vuelidate.short_name.$invalid : null"
      />
    </b-form-group>

    <b-form-group label="Account #" class="mb-3">
      <b-form-input
        v-model="form.account_number"
        type="text"
        class="form-control"
        placeholder="Account #"
        autocomplete="account_number"
        :disabled="customer && customer.id"
        :state="vuelidate.account_number.$dirty ? !vuelidate.account_number.$invalid : null"
      />
    </b-form-group>
  </div>
</template>

<script>
export default {
  name: 'CustomerFormGroup',
  props: {
    customer: {
      type: Object,
      default: () => {}
    },
    vuelidate: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      form: {
        full_name: null,
        short_name: null,
        account_number: null
      }
    }
  },
  watch: {
    form: {
      handler: function () {
        this.$emit('onCustomerChange', this.form)
      },
      deep: true
    }
  },
  created () {
    this.fillForm()
  },
  methods: {
    fillForm () {
      if (this.customer) {
        for (const i in this.form) {
          if (this.customer[i]) {
            this.form[i] = this.customer[i]
          }
        }
      }
    }
  }
}
</script>
